import React from 'react';

export const Hint = ({type, message, children}) => {

    return(<div className="chat-element-hint" style={{position: 'relative'}}>
        {!!type && <div className="chat-hint" style={{position: 'absolute', top: '-28px',
            whiteSpace: 'nowrap', right: 0, backgroundColor: type === 'info' ? 'black' : 'red',
            color: 'white', fontSize: '12px'}}>{message}</div>}
        {children}
    </div>)
}